import NoteIcon from '@mui/icons-material/Notes';
import RingIcon from '@mui/icons-material/Notifications';
import MailIcon from '@mui/icons-material/Mail';
import FireIcon from '@mui/icons-material/Whatshot';
import CallIcon from '@mui/icons-material/Call';
import FlagIcon from '@mui/icons-material/Flag';

const Icon = ({type, color}) => {

    const icons = {
        note: <NoteIcon color={color || 'action'} />,
        reminder: <RingIcon color={color || 'error'} />,
        email: <MailIcon color={color || 'primary'} />,
        deal: <FireIcon color={color || 'warning'} />,
        call: <CallIcon color={color || 'info'} />,
        flag: <FlagIcon color={color || 'secondary'} />,
    };

    return icons[type] || icons.note;
}

export default Icon;